module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/post-contato-serasa-57abfacd791f1ce6588d7b644a514b99.png";